import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_END_PATH_KEY } from '@/swagger/constants/surveys-keys';
import {
  API_POST_SURVEYS_CAMPAIGNS_ID_END,
  KEY_POST_SURVEYS_CAMPAIGN_BY_ID_END,
} from '../constats';
import { MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_END } from '../mocks';

type PostSurveysCampaignByIdEnd = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_END_PATH_KEY
>;

type RequestPostSurveysCampaignByIdEnd = PostSurveysCampaignByIdEnd['request']['path'];

type ResponsePostSurveysCampaignByIdEnd = PostSurveysCampaignByIdEnd['response']['body'];

type CallParamsPostSurveysCampaignByIdEnd = Omit<
  RequestPostSurveysCampaignByIdEnd,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostSurveysCampaignByIdEnd = ResponsePostSurveysCampaignByIdEnd;

type CallErrorPostSurveysCampaignByIdEnd = GenericApiError;

type CallSelectorsPostSurveysCampaignByIdEnd = {
  activeStep: ResponsePostSurveysCampaignByIdEnd;
};

export const postSurveysCampaignByIdEndCall = createGeneralCall<
  CallParamsPostSurveysCampaignByIdEnd,
  CallResponsePostSurveysCampaignByIdEnd,
  CallErrorPostSurveysCampaignByIdEnd,
  CallSelectorsPostSurveysCampaignByIdEnd
>({
  id: KEY_POST_SURVEYS_CAMPAIGN_BY_ID_END,
  method: 'post',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_SURVEYS_CAMPAIGNS_ID_END(org, payload.id);
    },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_END
    : undefined,
  selectors: {
    activeStep: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
});
